import React from "react";
import MainLayout from "../../../components/Layouts";
import SettlementOrderList from "../../../components/settlement/settledMentOrder";

const settlementOrder = () => {
  return (
    <MainLayout>
      <SettlementOrderList />
    </MainLayout>
  );
};

export default settlementOrder;
